<div id="wrapper">
    <!-- topbar -->
    <!-- <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()"
        layoutType="vertical"></app-topbar>  -->

    <!-- left side bar-->
    <app-left-sidebar [includeUserProfile]="showSidebarUserInfo">
    </app-left-sidebar>

    <div class="content-page">
        <div class="content">
            <!-- content -->
            <!-- *ngIf="reRender" -->
            <div class="container-fluid">
                <!-- <app-topbar (settingsButtonClicked)="onSettingsButtonClicked()"
                    (mobileMenuButtonClicked)="onToggleMobileMenu()" layoutType="vertical"></app-topbar> -->
                <div>

                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
        <!-- footer -->
        <!-- <app-footer></app-footer> -->
    </div>
</div>